var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"in-app-help",class:{
		'left-side': _vm.isFlowBuilder,
		'nudge-top': _vm.isGuidedTutorialOn,
		'builder-task-log-mode': _vm.isTaskLogOpen,
		'builder-version-history-mode': _vm.isVersionHistoryOpen,
	}},[_c('div',{staticClass:"in-app-help-button",on:{"click":_vm.toggleIsOpenHelpMenu}},[_c('InAppIcon',{attrs:{"isOpen":_vm.isOpen}})],1),_c('InAppHelpMenu',{staticClass:"help-menu-container",attrs:{"isOpen":_vm.isOpen,"isOnLeft":_vm.isFlowBuilder},on:{"setIsOpen":_vm.setIsOpen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }